module.exports = __webpack_public_path__ + "learnid.2f91d9e0.svg";